import { Box, Skeleton } from "@mui/material";
import React from "react";

export const CurrentProjectDetailsSkeleton: React.FC = () => {
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" pt={8} width="100%">
        <Box width="50%">
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="40%"
            height={30}
          />
          <Box mt={8}>
            <Skeleton variant="rectangular" animation="wave" height={40} />
          </Box>
          <Box display="flex" mt={12}>
            <Box width="20%">
              <Skeleton variant="rectangular" animation="wave" height={80} />
            </Box>
            <Box ml={8} width="40%">
              <Skeleton variant="rectangular" animation="wave" height={80} />
            </Box>
            <Box ml={8} width="20%">
              <Skeleton variant="rectangular" animation="wave" height={80} />
            </Box>
          </Box>
        </Box>

        <Box mt={8} width="37%" justifyContent="space-between">
          <Box mb={4}>
            <Skeleton variant="rectangular" animation="wave" height={40} />
          </Box>
          <Box mb={2}>
            <Skeleton variant="rectangular" animation="wave" height={30} />
          </Box>
          <Box mb={2}>
            <Skeleton variant="rectangular" animation="wave" height={30} />
          </Box>
          <Box mb={2}>
            <Skeleton variant="rectangular" animation="wave" height={30} />
          </Box>
        </Box>
      </Box>
      <Box mt={20}>
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="30%"
          height={25}
        />
      </Box>
      <Box mt={4}>
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="40%"
          height={25}
        />
      </Box>

      <Box mt={12}>
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="35%"
          height={35}
        />
      </Box>

      <Box mt={8} display="flex" alignItems="center">
        <Skeleton variant="circular" animation="wave" width={90} height={90} />
        <Box width="40%" ml={4}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="35%"
            height={30}
          />
          <Box pt={2}>
            <Skeleton
              variant="rectangular"
              animation="wave"
              width="20%"
              height={15}
            />
          </Box>
        </Box>
      </Box>
      <Box mt={8}>
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="15%"
          height={25}
        />
      </Box>
      <Box mt={8} width="40%" display="flex" justifyContent="space-between">
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="40%"
          height={20}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="40%"
          height={20}
        />
      </Box>

      <Box mt={4} width="50%" display="flex" justifyContent="space-between">
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="20%"
          height={20}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="20%"
          height={20}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="20%"
          height={20}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="20%"
          height={20}
        />
      </Box>
    </Box>
  );
};
